export const FETCH_PGR_PREVIEW = "FETCH_PGR_PREVIEW";
export const FETCH_TRABALHADORES_PGR_PREVIEW =
  "FETCH_TRABALHADORES_PGR_PREVIEW";
export const UPDATE_ENVIAR_PARA_TECNICO = "UPDATE_ENVIAR_PARA_TECNICO";
export const TOGGLE_STEP = "TOGGLE_STEP";
export const FINISH_STEP_FAIL = "FINISH_STEP_FAIL";
export const START_PREENCHIMENTO = "START_PREENCHIMENTO";
export const TOGGLE_STATUS = "TOGGLE_STATUS";
